var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { FileUpload } from "../../../shared/app/classes/file-upload";
import { HttpClientModule } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PayeeAttachmentDetail } from '../../../shared/sdk/models';
import { PayeeApi, StorageApi, PayeeSubmissionApi } from '../../../shared/sdk/services';
import { GlobalEventsManager } from '../../../events-manager.component';
import { SubmissionDetailService } from "../../../shared/app/services/";
import { LoopBackConfig } from "../../../shared/sdk/lb.config";
import { CONSTANT } from '../../../shared/app/constants';
var ɵ0 = window;
var POSOfferLetterComponent = /** @class */ (function (_super) {
    __extends(POSOfferLetterComponent, _super);
    function POSOfferLetterComponent(payeeApi, payeeSubmissionApi, router, storageApi, eventManager, submissionDetailService, sanitizer, http, document) {
        var _this = _super.call(this, payeeApi, storageApi, eventManager) || this;
        _this.payeeApi = payeeApi;
        _this.payeeSubmissionApi = payeeSubmissionApi;
        _this.router = router;
        _this.storageApi = storageApi;
        _this.eventManager = eventManager;
        _this.submissionDetailService = submissionDetailService;
        _this.sanitizer = sanitizer;
        _this.http = http;
        _this.document = document;
        _this.CONSTANT = CONSTANT;
        _this.TAG = "POSOfferLetterComponent";
        _this.new = false;
        _this.cardsPosSignedLoPayeeAttachedFileExists = false;
        _this.cardsPosSignedLgPayeeAttachedFileExists = false;
        _this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = false;
        _this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = false;
        _this.isPublicOrPrivate = false;
        _this.valid = true;
        _this.loSubTags = null;
        _this.checklistStatuses = ["Web Checklist Completed", "Merchant to review", "Pending Website Checklist Approval"];
        return _this;
    }
    // Initialisation
    POSOfferLetterComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // this.setUpFileUploader('cards_ecom_signed_lo_payee_attached');
                // console.log(this.TAG + "getOfferLetter: ");
                this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + ".pdf";
                if (window.screen.width < 1200) { // 768px portrait
                    this.isMobile = true;
                }
                this.getOfferLetter().subscribe(function (res) {
                    _this.eventsManager.loaded(true);
                    console.log(_this.TAG + "res: ");
                    console.log(res);
                    _this.submissionId = res.id;
                    _this.setUpFileUploader(null, _this.submissionId);
                    console.log(_this.TAG + "submissionId: ");
                    console.log(_this.submissionId);
                    //check is public or private entity
                    if (res['payee'] && res['payee']['details']) {
                        if (res.payee.details.business_entity == "Public Listed (Berhad)" || res.payee.details.business_entity == "Private Limited (Sendirian Berhad)")
                            _this.isPublicOrPrivate = true;
                    }
                    //check is opt in or out
                    if (res['payee'] && res['payee']['pos']) {
                        _this.pos = res.payee.pos;
                        console.log({ pos: _this.pos });
                        console.log({ opt_in: _this.pos.opt_in });
                    }
                    // console.log({isPublicOrPrivate: this.isPublicOrPrivate});
                    _this.documentsSetUp();
                    _this.attachment = res.attachments[0];
                    if (res.submission_subtags) {
                        _this.loSubTags = res.submission_subtags.filter(function (subtag) { return (subtag.subtag_id == 4 || subtag.subtag_id == 5); });
                        console.log(_this.TAG + "loSubTags: ");
                        console.log(_this.loSubTags);
                    }
                    if (_this.attachment.hasOwnProperty('detail')) {
                        _this.detail = _this.attachment.detail;
                    }
                    else {
                        _this.detail = null;
                    }
                    if (!_this.detail) {
                        _this.detail = new PayeeAttachmentDetail;
                        console.log("no detail so create one:");
                        _this.new = true;
                        console.log(_this.detail);
                    }
                    _this.file_name = _this.attachment.file_name;
                    // this.src = this.getTrustedURL(LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.attachment.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id);
                    // this.optOutSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/doc/download/Merchants_OptOut_Form.pdf" + "?access_token=" + this.payeeApi.getCurrentToken().id;
                    _this.optOutSrc = "assets/form/Merchants_OptOut_Form.pdf";
                    _this.mobileSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + _this.payeeApi.getCurrentId() + "/download/" + _this.attachment.file_name + "?access_token=" + _this.payeeApi.getCurrentToken().id;
                }, function (err) {
                    _this.eventsManager.loaded(true);
                    console.log(err);
                    _this.router.navigate(['/dashboard']);
                });
                return [2 /*return*/];
            });
        });
    };
    POSOfferLetterComponent.prototype.getOfferLetter = function () {
        var filter = {
            include: [
                {
                    relation: "attachments",
                    scope: {
                        where: {
                            "or": [
                                {
                                    'type': "cards_pos_lo_admin",
                                    'isDeleted': false
                                },
                            ]
                        },
                        include: "detail",
                        order: 'created_at ASC',
                        limit: 1
                    }
                },
                {
                    relation: "submission_subtags",
                    scope: {
                        where: {
                            'deleted_at': null
                        }
                    }
                },
                {
                    relation: "payee",
                    scope: {
                        include: [
                            "details",
                            "pos"
                        ]
                    }
                },
            ]
        };
        return this.payeeSubmissionApi.findById(this.submissionDetailService.getCurrentSubmissionId(), filter);
    };
    POSOfferLetterComponent.prototype.documentsSetUp = function () {
        var _this = this;
        this.getFileDetails('cards_pos_signed_lo_payee_attached').subscribe(function (res) {
            if (res.length > 0) {
                _this.cardsPosSignedLoPayeeAttachedFileExists = true;
                _this.posSignedLoPayeeAttachedFileName = res[0].file_name;
            }
            else {
                _this.cardsPosSignedLoPayeeAttachedFileExists = false;
            }
        });
        this.getFileDetails('cards_pos_signed_lg_payee_attached').subscribe(function (res) {
            if (res.length > 0) {
                _this.cardsPosSignedLgPayeeAttachedFileExists = true;
                _this.posSignedLgPayeeAttachedFileName = res[0].file_name;
            }
            else {
                _this.cardsPosSignedLgPayeeAttachedFileExists = false;
            }
        });
        this.getFileDetails('cards_pos_signed_payment_slip_payee_attached').subscribe(function (res) {
            if (res.length > 0) {
                _this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = true;
                _this.posSignedPaymentSlipPayeeAttachedFileName = res[0].file_name;
            }
            else {
                _this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = false;
            }
        });
        this.getFileDetails('cards_pos_signed_opt_out_declaration_form_payee_attached').subscribe(function (res) {
            if (res.length > 0) {
                _this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = true;
                _this.posSignedDeclarationFormPayeeAttachedFileName = res[0].file_name;
            }
            else {
                _this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = false;
            }
        });
    };
    POSOfferLetterComponent.prototype.createNewOfferLetterDetail = function () {
        return this.payeeApi.createAttachmentsDetail(this.attachment.payee_id, this.attachment.id, this.detail);
    };
    POSOfferLetterComponent.prototype.updateOfferLetterDetail = function () {
        return this.payeeApi.updateAttachmentsDetail(this.attachment.payee_id, this.attachment.id, this.detail);
    };
    POSOfferLetterComponent.prototype.updatePosOpt = function () {
        return this.payeeApi.updatePos(this.attachment.payee_id, this.pos);
    };
    POSOfferLetterComponent.prototype.getTrustedURL = function (url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    POSOfferLetterComponent.prototype.populateFormData = function () {
        this.eventsManager.loaded(true);
        // this.payeeApi.getCmoWebChecklist(this.payeeApi.getCurrentId(), {
        //   // where: {'merchant_to_review': 1},
        //   order:'created_at DESC',
        //   include:{
        //     "relation": "adminChecklist",
        //     "scope": {
        //         "include": ["remarks"]
        //   }
        // }}).subscribe(
        //   checklists => {
        //     console.log(checklists);
        //     if (checklists.length == 0) {
        //       this.details.payee_id = this.payeeApi.getCurrentId();
        //     } else {
        //         this.details = checklists[0];
        //         this.adminChecklist = checklists[0].adminChecklist;
        //         this.adminChecklistRemark = checklists[0].adminChecklist.remarks;
        //     }
        //     this.eventsManager.loaded(true);
        //   },
        //   err => {
        //     console.log(err);
        //     this.eventsManager.logout(true);
        //     this.eventsManager.showPopUp("Your session has expired. Please login.");
        //     this.eventsManager.loaded(true);
        //   }
        // );
    };
    POSOfferLetterComponent.prototype.addEventListeners = function () { };
    POSOfferLetterComponent.prototype.submit = function (submit) {
        var _this = this;
        // Send to temp storage
        var promises = [];
        var that = this;
        this.valid = (this.detail.acceptance != null) ? true : false;
        console.log(this.valid);
        this.valid = ((this.detail.acceptance == false && this.detail.reason != null) || (this.detail.acceptance == true)) ? true : false;
        console.log(this.valid);
        this.validateDocs();
        this.valid = this.docsValid && this.valid;
        // this.detail.submission
        console.log(this.TAG + ":this.detail");
        console.log(this.detail);
        console.log(this.TAG + ":this.pos");
        console.log(this.pos);
        if (this.valid) {
            console.log(this.TAG + ":submit");
            //check whether acceptance is no then delete the attached docs
            if (!this.detail.acceptance) {
                this.deleteDocs();
            }
            if (this.detail.acceptance) {
                this.detail.reason = null;
            }
            if (this.new) {
                this.createNewOfferLetterDetail().subscribe(function (createNewOfferLetterDetailRes) {
                    console.log({ createNewOfferLetterDetailRes: createNewOfferLetterDetailRes });
                    //update Pos
                    _this.updatePosOpt().subscribe(function (updatePosOptRes) {
                        console.log({ updatePosOptRes: updatePosOptRes });
                        _this.eventsManager.showPopUp("You have successfully submitted.");
                        _this.router.navigate(['/dashboard']);
                    }, function (updatePosOptErr) {
                        console.log({ updatePosOptErr: updatePosOptErr });
                        _this.eventsManager.showPopUp("Unable to submit. Please try again later");
                    });
                    // this.eventsManager.showPopUp("Submitted.");
                    // this.router.navigate(['/dashboard']);
                }, function (createNewOfferLetterDetailErr) {
                    console.log({ createNewOfferLetterDetailErr: createNewOfferLetterDetailErr });
                    _this.eventsManager.showPopUp("Unable to submit. Please try again later");
                });
            }
            else {
                this.updateOfferLetterDetail().subscribe(function (updateOfferLetterDetaiLRes) {
                    console.log({ updateOfferLetterDetaiLRes: updateOfferLetterDetaiLRes });
                    //update Pos
                    _this.updatePosOpt().subscribe(function (updatePosOptRes) {
                        console.log({ updatePosOptRes: updatePosOptRes });
                        _this.eventsManager.showPopUp("You have successfully submitted.");
                        _this.router.navigate(['/dashboard']);
                    }, function (updatePosOptErr) {
                        console.log({ updatePosOptErr: updatePosOptErr });
                        _this.eventsManager.showPopUp("Unable to submit. Please try again later");
                    });
                    // this.eventsManager.showPopUp("Updated.");
                    // this.router.navigate(['/dashboard']);
                }, function (updateOfferLetterDetaiLErr) {
                    console.log({ updateOfferLetterDetaiLErr: updateOfferLetterDetaiLErr });
                    _this.eventsManager.showPopUp("Unable to submit. Please try again later");
                });
            }
        }
    };
    POSOfferLetterComponent.prototype.downloadFile = function () {
        this.oldownload.nativeElement.click();
        // var win = open(this.mobileSrc,'windowName','height=300,width=300');
        // win.document.write("");
        // window.open(this.mobileSrc);
        // this.download(this.file_name);
        // let url=this.mobileSrc;
        // this.http.get(url).map(
        //     (res) => {
        //         console.log(res);
        //         return new Blob([res.blob()], { type: 'application/pdf' })
        //     })
    };
    POSOfferLetterComponent.prototype.downloadOptOutFile = function () {
        this.optOutdownload.nativeElement.click();
    };
    POSOfferLetterComponent.prototype.validateDocs = function () {
        this.docsValid = true;
        if (this.detail.acceptance) {
            if (!this.cardsPosSignedLoPayeeAttachedFileExists) {
                this.docsValid = false;
            }
            if (this.isPublicOrPrivate && !this.cardsPosSignedLgPayeeAttachedFileExists) {
                this.docsValid = false;
            }
            // if (!this.cardsEcomSignedPaymentSlipPayeeAttachedFileExists ) {
            //   this.docsValid = false;
            // }
            if (!this.pos.opt_in && !this.cardsPosSignedDeclarationFormPayeeAttachedFileExists) {
                this.docsValid = false;
            }
        }
    };
    // File manipulation methods
    POSOfferLetterComponent.prototype.updateDocStatus = function (name, fileName) {
        // this.cardsEcomSignedLoPayeeAttachedFileExists = true;
        // this.fileName = fileName;
        switch (name) {
            case 'cards_pos_signed_lo_payee_attached':
                this.cardsPosSignedLoPayeeAttachedFileExists = true;
                if (fileName) {
                    this.posSignedLoPayeeAttachedFileName = fileName;
                }
                break;
            case 'cards_pos_signed_lg_payee_attached':
                this.cardsPosSignedLgPayeeAttachedFileExists = true;
                if (fileName) {
                    this.posSignedLgPayeeAttachedFileName = fileName;
                }
                break;
            case 'cards_pos_signed_payment_slip_payee_attached':
                this.cardsPosSignedPaymentSlipPayeeAttachedFileExists = true;
                if (fileName) {
                    this.posSignedPaymentSlipPayeeAttachedFileName = fileName;
                }
                break;
            case 'cards_pos_signed_opt_out_declaration_form_payee_attached':
                this.cardsPosSignedDeclarationFormPayeeAttachedFileExists = true;
                if (fileName) {
                    this.posSignedDeclarationFormPayeeAttachedFileName = fileName;
                }
                break;
        }
    };
    POSOfferLetterComponent.prototype.deleteDocs = function () {
        if ((!this.cardsPosSignedLoPayeeAttachedFileExists && this.posSignedLoPayeeAttachedFileName != null) || !this.detail.acceptance) {
            this.deleteDoc('cards_pos_signed_lo_payee_attached');
        }
        if ((!this.cardsPosSignedLgPayeeAttachedFileExists && this.posSignedLgPayeeAttachedFileName != null) || !this.detail.acceptance) {
            this.deleteDoc('cards_pos_signed_lg_payee_attached');
        }
        if ((!this.cardsPosSignedPaymentSlipPayeeAttachedFileExists && this.posSignedPaymentSlipPayeeAttachedFileName != null) || !this.detail.acceptance) {
            this.deleteDoc('cards_pos_signed_payment_slip_payee_attached');
        }
        if ((!this.cardsPosSignedDeclarationFormPayeeAttachedFileExists && this.posSignedDeclarationFormPayeeAttachedFileName != null) || this.pos.opt_in) {
            this.deleteDoc('cards_pos_signed_opt_out_declaration_form_payee_attached');
        }
    };
    // Scrolling
    POSOfferLetterComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
    };
    POSOfferLetterComponent.prototype.scrollToSave = function () {
        document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
    };
    return POSOfferLetterComponent;
}(FileUpload));
export { POSOfferLetterComponent };
export { ɵ0 };
